module.exports = __webpack_public_path__ + "media/images/front/centres/centre_vilareal-6d38496f5ab28acce6235adfc5a0fb2e.jpg";